export class ContextMenu {
  constructor({ options = [], target, autoActive }) {
    if (!options.length) return;
    this.options = options;
    this.target = target;
    this.autoActive = autoActive;
    this.menu = null;

    this.boundCloseMenu = this.closeMenu.bind(this);

    if (this.autoActive) {
      this.target.addEventListener('contextmenu', (e) => this.openMenu(e));
    }
  }

  createMenu() {
    const menu = document.createElement('div');
    menu.classList.add('dropdown-menu', 'show');
    menu.style.position = 'absolute';

    requestAnimationFrame(() => {
      document.addEventListener('click', this.boundCloseMenu);
      document.addEventListener('contextmenu', this.boundCloseMenu);
    });

    this.options.forEach((option) => {
      if (option === 'separator') {
        const divider = document.createElement('div');
        divider.classList.add('dropdown-divider');
        menu.appendChild(divider);
      } else {
        const item = document.createElement('div');
        item.classList.add('dropdown-item');
        item.innerText = option.text;

        item.addEventListener('click', (e) => this.handleAction(option, e));

        menu.appendChild(item);
      }
    });

    return menu;
  }

  handleAction(option, e) {
    const targetElement = e.target.closest(this.target.tagName.toLowerCase());
    const data = getDataAll(targetElement);

    if (option.type === 'send') {
      const value = typeof option.value === 'object' ? option.value : { url: option.value, data };
      new SendData(value);
    } else if (option.type === 'modal') {
      const value = typeof option.value === 'object' ? option.value : { url: option.value, data };
      new ModalManager(value).open();
    } else if (option.type === 'link') {
      const value =
        typeof option.value === 'object'
          ? option.value
          : {
              link: option.value,
              data: data,
              get: true
            };
      href(value);
    }

    this.closeMenu();
  }

  openMenu(e) {
    if (e.ctrlKey) return;
    e.preventDefault();
    // Если меню ещё не создано, создаём и добавляем в DOM

    requestAnimationFrame(() => {
      if (!this.menu) {
        this.menu = this.createMenu();
        document.body.appendChild(this.menu);
      }

      this.menu.style.left = `${e.pageX}px`;
      this.menu.style.top = `${e.pageY}px`;
      this.menu.style.display = 'block';
    });
  }

  closeMenu() {
    if (this.menu) {
      this.menu.remove(); // Удаляем элемент из DOM
      this.menu = null; // Обнуляем ссылку на меню
      document.removeEventListener('click', this.boundCloseMenu);
      document.removeEventListener('contextmenu', this.boundCloseMenu);
    }
  }
}
